export default __webpack_public_path__ + "static/media/file-text.adcc5c5b.svg";